import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import * as THREE from 'three';
import Button from '../ui/Button';
const Hero = () => {
  const globeRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!globeRef.current) return;
    // Set up Three.js scene
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, 1, 0.1, 1000);
    const renderer = new THREE.WebGLRenderer({
      alpha: true,
      antialias: true
    });
    renderer.setSize(300, 300);
    globeRef.current.appendChild(renderer.domElement);
    // Create a simple globe
    const geometry = new THREE.SphereGeometry(1, 32, 32);
    const material = new THREE.MeshBasicMaterial({
      color: 0x1c71b8,
      wireframe: true,
      transparent: true,
      opacity: 0.7
    });
    const globe = new THREE.Mesh(geometry, material);
    scene.add(globe);
    camera.position.z = 2.5;
    // Add ambient light
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
    scene.add(ambientLight);
    // Add point light
    const pointLight = new THREE.PointLight(0xffffff, 0.5);
    pointLight.position.set(5, 3, 5);
    scene.add(pointLight);
    // Animation loop
    const animate = () => {
      requestAnimationFrame(animate);
      globe.rotation.y += 0.005;
      globe.rotation.x += 0.002;
      renderer.render(scene, camera);
    };
    animate();
    // Cleanup
    return () => {
      if (globeRef.current && globeRef.current.contains(renderer.domElement)) {
        globeRef.current.removeChild(renderer.domElement);
      }
      geometry.dispose();
      material.dispose();
      renderer.dispose();
    };
  }, []);
  return <div className="relative bg-gradient-to-r from-neutral-light to-white min-h-screen flex items-center" data-id="element-43">
      <div className="absolute top-0 right-0 w-full h-full overflow-hidden" data-id="element-44">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-toronto-blue/5 transform skew-x-12" style={{
        zIndex: 0
      }} data-id="element-45" />
      </div>
      <div className="container mx-auto px-4 md:px-6 py-24 relative z-10" data-id="element-46">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-47">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-48">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold mb-6" data-id="element-49">
              <span className="text-neutral-dark" data-id="element-50">Global Insight.</span>
              <br data-id="element-51" />
              <span className="text-toronto-blue" data-id="element-52">Local Intelligence.</span>
            </h1>
            <p className="text-lg md:text-xl text-neutral-dark/80 mb-8 max-w-lg" data-id="element-53">
              Market Research Toronto delivers world-class insights with deep
              local expertise, helping organizations make data-driven decisions
              in our multicultural metropolis and beyond.
            </p>
            <div className="flex flex-wrap gap-4" data-id="element-54">
              <Button variant="primary" size="lg" data-id="element-55">
                Schedule a Consultation
              </Button>
              <Button variant="outline" size="lg" data-id="element-56">
                Explore Our Work
              </Button>
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.3,
          duration: 1
        }} className="flex justify-center items-center" data-id="element-57">
            <div className="relative" data-id="element-58">
              <div ref={globeRef} className="w-[300px] h-[300px] mx-auto" data-id="element-59" />
              <motion.div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[280px] h-[280px] rounded-full" animate={{
              boxShadow: ['0 0 20px rgba(28, 113, 184, 0.3)', '0 0 40px rgba(28, 113, 184, 0.2)'],
              scale: [1, 1.05, 1]
            }} transition={{
              repeat: Infinity,
              duration: 4
            }} data-id="element-60" />
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
};
export default Hero;